module.exports = __webpack_public_path__ + "img/13.096459b8.jpg";